module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9yZvM"))).then(() => parcelRequire('hEqeo'));